<template>
  <div :v-if="show" class="graph">
    <v-network-graph
      :nodes="nodes"
      :edges="edges"
      :configs="configs"
      :event-handlers="eventHandlers"
    >
      <template #override-node="{ nodeId, scale, config, ...slotProps }">
        <circle
          v-bind="slotProps"
          :ref="nodeId"
          :r="config.radius * scale"
          fill="white"
          stroke="lightgrey"
          :stroke-width="size.default"
        />
      </template>
    </v-network-graph>

    <label class="switch">
      <input type="checkbox" v-model="testCaseCondition" />
      <span>Toggle: On node hover change edge style</span>
    </label>
    <div class="legend">
      <div
        v-for="(hue, name, index) in hues"
        :key="name"
        :style="{ backgroundColor: generateColor(hue) }"
        @mouseover="handleHoverColor(hue)"
        @mouseout="handleHoverColorOut(hue)"
      >
        {{ index }}. {{ name }}
      </div>
    </div>
  </div>
</template>

<script>
import { configs } from "./config/config";
import Papa from "papaparse";
export default {
  data: () => ({
    nodes: {},
    edges: [],
    hues: {
      default: 0,
      hover: 100,
      beziehung: 300,
      schule: 200,
      verwand: 130,
      party: 47,
      noData: 244,
      nachbarn: 173,
      zocken: 259,
      socialNetworks: 151,
    },
    size: {
      default: 3,
      hover: 8,
    },
    testCaseCondition: true,
    csvData: [],
    show: false,
  }),

  computed: {
    configs,
    eventHandlers() {
      return {
        "node:pointerover": ({ node }) => {
          this.handleHoverNode(node, "hover");
        },

        "node:pointerout": ({ node }) => {
          this.handleHoverNode(node, "default", "lightgrey");
        },

        "edge:pointerover": ({ edge }) => {
          this.handleHoverEdge(edge, "hover");
        },

        "edge:pointerout": ({ edge }) => {
          this.handleHoverEdge(edge, "default", "lightgrey");
        },
      };
    },
  },

  methods: {
    generateColor(hue) {
      return `hsl(${hue}, 85%, 68%)`;
    },
    createData() {
      this.fetchCSVData();
      console.log("abs", this.csvData);
    },
    async fetchCSVData() {
      try {
        const response = await fetch("/data.csv"); // Adjust the file path based on your CSV file location
        const csvText = await response.text();
        const { data } = Papa.parse(csvText, { header: true });
        this.csvData = data;
        const a = this.calculateEdgesAndNotes(data);
        this.show = true;
        console.log("a", a);
      } catch (error) {
        console.error("Error fetching/parsing CSV data:", error);
      }
    },
    calculateEdgesAndNotes(data) {
      data.forEach((row) => {
        const sourceNode = row.P1;
        const targetNode = row.P2;
        const beziehungsArt = row.beziehungsArt;
        const edgeId = `${sourceNode}-${targetNode}`;

        if (!sourceNode || !targetNode) {
          console.log(
            "!sourceNode || !targetNode",
            row,
            sourceNode,
            targetNode,
            edgeId
          );
          return;
        }
        if (!this.nodes[sourceNode]) {
          this.nodes[sourceNode] = {
            name: sourceNode,
            id: sourceNode,
            edgeWidth: this.size.default,
            hue: this.hues[beziehungsArt] ?? this.hues.default,
          };
        }
        if (!this.nodes[targetNode]) {
          this.nodes[targetNode] = {
            name: targetNode,
            id: targetNode,
            edgeWidth: this.size.default,
            hue: this.hues[beziehungsArt] ?? this.hues.default,
          };
        }

        this.edges.push({
          source: sourceNode,
          target: targetNode,
          edgeWidth: this.size.default,
          hue: this.hues[beziehungsArt] ?? this.hues.default,
        });
      });
    },
    handleHoverNode(node, size, color) {
      this.edges.forEach((edge) => {
        if (edge.source === node || edge.target === node) {
          if (this.testCaseCondition) {
            edge.edgeWidth = this.size[size];
          }

          const defaultColor = `hsl(${edge.hue}, 85%, 68%)`;
          this.$refs[edge.source].style.stroke = color ?? defaultColor;
          this.$refs[edge.source].style.strokeWidth = this.size[size];

          this.$refs[edge.target].style.stroke = color ?? defaultColor;
          this.$refs[edge.target].style.strokeWidth = this.size[size];
        }
      });
    },
    handleHoverColor(hue) {
      const size = this.size.hover;
      this.edges.forEach((edge) => {
        if (edge.hue === hue || edge.hue === hue) {
          if (this.testCaseCondition) {
            edge.edgeWidth = size;
          }

          const defaultColor = `hsl(${edge.hue}, 85%, 68%)`;
          this.$refs[edge.source].style.stroke = defaultColor;
          this.$refs[edge.source].style.strokeWidth = size;

          this.$refs[edge.target].style.stroke = defaultColor;
          this.$refs[edge.target].style.strokeWidth = size;
        }
      });
    },
    handleHoverColorOut(hue) {
      const size = this.size.default;
      this.edges.forEach((edge) => {
        if (edge.hue === hue || edge.hue === hue) {
          if (this.testCaseCondition) {
            edge.edgeWidth = size;
          }

          const defaultColor = `hsl(${edge.hue}, 85%, 68%)`;
          this.$refs[edge.source].style.stroke = defaultColor;
          this.$refs[edge.source].style.strokeWidth = size;

          this.$refs[edge.target].style.stroke = defaultColor;
          this.$refs[edge.target].style.strokeWidth = size;
        }
      });
    },

    handleHoverEdge(edge, size, color) {
      const { source, target, hue } = this.edges[edge];
      const defaultColor = `hsl(${hue}, 85%, 68%)`;

      this.$refs[source].style.strokeWidth = this.size[size];
      this.$refs[target].style.strokeWidth = this.size[size];

      this.$refs[source].style.stroke = color ?? defaultColor;
      this.$refs[target].style.stroke = color ?? defaultColor;
    },
  },
  mounted() {
    this.createData();
    console.log("this.nodes", this.nodes);
    console.log("this.edges", this.edges);
  },
};
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
  font-family: sans-serif;
}

.graph,
.v-network-graph > svg {
  width: 100vw !important;
  height: 100vh !important;
  overflow: hidden;
}

.switch {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  padding: 20px;
  background-color: #eee;
  cursor: pointer;
}
.legend {
  position: fixed;
  top: 100px;
  left: 0;
  align-items: center;
  padding: 20px;
  background-color: #eee;
  cursor: pointer;
}

.switch input {
  width: 20px;
  height: 20px;
  margin: 0 10px 0 0;
  padding: 0;
}
</style>
